import type { AvatarKey } from "@al-life/types";
import { AVATAR_LABELS, AVATAR_SRC } from "./avatars";

/**
 * Renders a bundled cartoon avatar by key. `size` is the pixel diameter.
 */
export function Avatar({
  avatarKey,
  size = 32,
  className,
}: {
  avatarKey: AvatarKey;
  size?: number;
  className?: string;
}) {
  return (
    <img
      src={AVATAR_SRC[avatarKey]}
      alt={`${AVATAR_LABELS[avatarKey]} avatar`}
      width={size}
      height={size}
      className={className}
      style={{ borderRadius: "50%", display: "block" }}
    />
  );
}
